// extracted by mini-css-extract-plugin
export default {"spinner_container":"Spinner_spinner_container__mYnOH"};